import { useCallback, useState } from 'react';

import { logger } from '@/utils/logger/logger';

type CopiedValue = string | null;
type CopyFunction = (text: string) => Promise<boolean>;

const TAG = 'CopyToClipboard: ';
export function useCopyToClipboard(): [CopiedValue, CopyFunction] {
  const [copiedText, setCopiedText] = useState<CopiedValue>(null);

  const copy: CopyFunction = useCallback(async text => {
    if (!navigator?.clipboard) {
      logger.warn(TAG, 'Clipboard not supported');
      return false;
    }

    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);

      return true;
    } catch (error) {
      logger.warn(TAG, 'Copy failed', error);
      setCopiedText(null);

      return false;
    }
  }, []);

  return [copiedText, copy];
}
